export enum ShipmentDateOptions {
  AllTime = 'AllTime',
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
}

export enum ShipmentStatus {
  None = '',
  New = 'NEW',
  OrderPlaced = 'ORDER_PLACED',
  Assigned = 'ASSIGNED',
  Accepted = 'ACCEPTED',
  DriverAccepted = 'DRIVER_ACCEPTED',
  InTransit = 'IN_TRANSIT',
  ArrivePickupLocation = 'ARRIVED_AT_PICKUP_LOCATION',
  GoodsLoaded = 'GOODS_LOADED',
  ArriveDropOffLocation = 'ARRIVED_AT_DROP_OFF_LOCATION',
  GoodsDelivered = 'GOODS_DELIVERED',
  Canceled = 'CANCELED',
  NotFulfilled = 'NOT_FULFILLED',
  Rejected = 'REJECTED',
  Closed = 'CLOSED',
  Start = 'TRIP_STARTED',
  AutoDelivered = 'AUTO_DELIVERED', // FE only
}

export enum ReceiverShipmentStatus {
  None = '',
  New = 'NEW',
  OrderPlaced = 'ORDER_PLACED',
  Accepted = 'ACCEPTED',
  Assigned = 'ASSIGNED',
  DriverAccepted = 'DRIVER_ACCEPTED',
  InTransit = 'IN_TRANSIT',
  ArrivePickupLocation = 'ARRIVED_AT_PICKUP_LOCATION',
  GoodsLoaded = 'GOODS_LOADED',
  GoodsDelivered = 'GOODS_DELIVERED',
  ArriveDropOffLocation = 'ARRIVED_AT_DROP_OFF_LOCATION',
  Returned = 'RETURNED',
  Rejected = 'REJECTED',
  InComplete = 'INCOMPLETE',
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  DriverAssigned = 'DRIVER_ASSIGNED',
  FleetAssigned = 'FLEET_ASSIGNED',
  FleetAccepted = 'FLEET_ACCEPTED',
  TripStarted = 'TRIP_STARTED',
  ShipmentCreated = 'SHIPMENT_CREATED',
}

export enum DriverAndTruckShipmentStatus {
  None = '',
  Assigned = 'ASSIGNED',
  GoodsDelivered = 'GOODS_DELIVERED',
  Accepted = 'ACCEPTED',
  ArriveDropOffLocation = 'ARRIVED_AT_DROP_OFF_LOCATION',
  GoodsLoaded = 'GOODS_LOADED',
  InTransit = 'IN_TRANSIT',
  ArrivePickupLocation = 'ARRIVED_AT_PICKUP_LOCATION',
  NotFulfilled = 'NOT_FULFILLED',
  Canceled = 'CANCELED',
  Rejected = 'REJECTED',
  Closed = 'CLOSED',
}

export enum ShipmentAction {
  Create = 'SHIPMENT_CREATED',
  AssignFleet = 'FLEET_ASSIGNED',
  AcceptFleet = 'FLEET_ACCEPTED',
  ReassignFleet = 'FLEET_REASSIGNED',
  AssignDriver = 'DRIVER_ASSIGNED',
  AcceptDriver = 'DRIVER_ACCEPTED',
  Start = 'TRIP_STARTED',
  ArrivePickupLocation = 'ARRIVED_AT_PICKUP_LOCATION',
  GoodsLoaded = 'GOODS_LOADED',
  ArriveDropOffLocation = 'ARRIVED_AT_DROP_OFF_LOCATION',
  GoodsDelivered = 'GOODS_DELIVERED',
  Cancel = 'CANCELED',
  NotFulfilled = 'NOT_FULFILLED',
  Reject = 'REJECTED',
  Decline = 'DECLINED',
  Close = 'CLOSED',
}

export enum ShipmentType {
  Custom = 'CUSTOM',
  Contracted = 'CONTRACTED',
  Freelance = 'FREELANCE',
}

export enum DeliveryNoteStatus {
  ALL = 'ALL',
  AVAILABLE_TO_BE_ISSUED = 'AVAILABLE_TO_BE_ISSUED',
  NOT_RECEIVED = 'NOT_RECEIVED',
  ISSUED = 'ISSUED',
}

export enum InvoiceStatus {
  Paid = 'PAID',
  UnPaid = 'UNPAID',
  Rejected = 'REJECTED',
  Drafted = 'DRAFTED',
  In_Progress = 'IN_PROGRESS',
  OverDue = 'OVER_DUE',
  CashOnDelivery = 'CASH_ON_DELIVERY',
}

export enum ShipmentAssignedFleetsType {
  All = 'ALL',
  WithoutSpecific = 'WITHOUT_SPECIFIC',
  Specific = 'SPECIFIC',
}

export enum ShipmentDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND',
}

export enum ShipmentTransportationPaymentStatus {
  Paid = 'PAID',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}

export enum ShipmentRequestLocationType {
  PickUp = 'PICK_UP',
  Delivery = 'DELIVERY',
  Return = 'RETURN',
  Start = 'START',
  InTransit = 'IN_TRANSIT',
}

export enum ShipmentRequestsMultiplicationType {
  Single = 'SINGLE',
  Multiple = 'MULTIPLE',
}

export enum TrackingType {
  All = 'All',
  AVL = 'AVL',
  Mobile = 'MOBILE',
  Empty = 'EMPTY',
}

export enum TrailerLabel {
  Hold = 'HOLD',
  Closed = 'CLOSED',
}

export enum ShipmentsViewableColumns {
  id = 'ID',
  createdAt = 'CREATED_AT',
  pickUpDate = 'PICKUP_DATE',
  requestedDeliveryDate = 'Requested_Delivery_Date',
  customerName = 'BRANCH',
  ReceiverName = 'CUSTOMER',
  numberOfRequests = 'NUMBER_OF_REQUESTS',
  from = 'PICKUP_LOCATION',
  to = 'DROPOFF_LOCATION',
  price = 'PRICE',
  status = 'STATUS',
  product = 'PRODUCT',
  createdBy = 'CREATED_BY',
  fleetName = 'FLEET',
  driverName = 'DRIVER',
  trackingType = 'TRACKING_TYPE_TITLE',
  truckType = 'VEHICLE_TYPE',
  dropOffUserName = 'DROPOFF_CONTACT',
  optionalTruckTypes = 'ALTERNATIVE_VEHICLE_TYPE',
  direction = 'DIRECTION',
  driverAllowance = 'DRIVER_ALLOWANCE',
  iqamaId = 'IQAMA_ID',
  mobileNumber = 'MOBILE_NUMBER',
  assignedByName = 'ASSIGNED_BY_NAME',
  assignedBy = 'ASSIGNED_BY',
  notes = 'NOTES',
  truckPlateNumber = 'TRUCK_PLATE_NUMBER',
  deliveryDate = 'DELIVERY_DATE',
  deliveryNote = 'DELIVERY_NOTE',
}

export enum SAASShipmentsViewableColumns {
  id = 'ID',
  createdAt = 'CREATED_AT',
  pickUpDate = 'PICKUP_DATE',
  requestedDeliveryDate = 'Requested_Delivery_Date',
  customerName = 'BRANCH',
  ReceiverName = 'CUSTOMER',
  numberOfRequests = 'NUMBER_OF_REQUESTS',
  from = 'PICKUP_LOCATION',
  to = 'DROPOFF_LOCATION',
  price = 'PRICE',
  status = 'STATUS',
  product = 'PRODUCT',
  createdBy = 'CREATED_BY',
  fleetName = 'FLEET',
  driverName = 'DRIVER',
  trackingType = 'TRACKING_TYPE_TITLE',
  truckType = 'VEHICLE_TYPE',
  dropOffUserName = 'DROPOFF_CONTACT',
  optionalTruckTypes = 'ALTERNATIVE_VEHICLE_TYPE',
  direction = 'DIRECTION',
  driverAllowance = 'DRIVER_ALLOWANCE',
  iqamaId = 'IQAMA_ID',
  mobileNumber = 'MOBILE_NUMBER',
  assignedByName = 'ASSIGNED_BY_NAME',
  assignedBy = 'ASSIGNED_BY',
  deliveryNote = 'DELIVERY_NOTE',
  notes = 'NOTES',
  truckPlateNumber = 'TRUCK_PLATE_NUMBER',
  deliveryDate = 'DELIVERY_DATE',
}

export enum FleetShipmentsViewableColumns {
  id = 'ID',
  createdAt = 'CREATED_AT',
  pickUpDate = 'PICKUP_DATE',
  requestedDeliveryDate = 'Requested_Delivery_Date',
  customerName = 'CUSTOMER',
  ReceiverName = 'RECEIVER',
  numberOfRequests = 'NUMBER_OF_REQUESTS',
  from = 'PICKUP_LOCATION',
  to = 'DROPOFF_LOCATION',
  price = 'PRICE',
  status = 'STATUS',
  product = 'PRODUCT',
  createdBy = 'CREATED_BY',
  driverName = 'DRIVER',
  trackingType = 'TRACKING_TYPE_TITLE',
  truckType = 'VEHICLE_TYPE',
  dropOffUserName = 'DROPOFF_CONTACT',
  optionalTruckTypes = 'ALTERNATIVE_VEHICLE_TYPE',
  direction = 'DIRECTION',
  driverAllowance = 'DRIVER_ALLOWANCE',
  iqamaId = 'IQAMA_ID',
  mobileNumber = 'MOBILE_NUMBER',
  assignedByName = 'ASSIGNED_BY_NAME',
  assignedBy = 'ASSIGNED_BY',
  notes = 'NOTES',
  deliveryNote = 'DELIVERY_NOTE',
  truckPlateNumber = 'TRUCK_PLATE_NUMBER',
  deliveryDate = 'DELIVERY_DATE',
}

export enum OrganizationShipmentsViewableColumns {
  id = 'ID',
  createdAt = 'CREATED_AT',
  pickUpDate = 'PICKUP_DATE',
  requestedDeliveryDate = 'Requested_Delivery_Date',
  customerName = 'SHIPPER',
  ReceiverName = 'FINAL_RECEIVER',
  numberOfRequests = 'NUMBER_OF_REQUESTS',
  from = 'PICKUP_LOCATION',
  to = 'DROPOFF_LOCATION',
  price = 'PRICE',
  status = 'STATUS',
  product = 'PRODUCT',
  createdBy = 'CREATED_BY',
  fleetName = 'FLEET',
  driverName = 'DRIVER',
  trackingType = 'TRACKING_TYPE_TITLE',
  truckType = 'VEHICLE_TYPE',
  dropOffUserName = 'DROPOFF_CONTACT',
  optionalTruckTypes = 'ALTERNATIVE_VEHICLE_TYPE',
  direction = 'DIRECTION',
  driverAllowance = 'DRIVER_ALLOWANCE',
  iqamaId = 'IQAMA_ID',
  mobileNumber = 'MOBILE_NUMBER',
  assignedByName = 'ASSIGNED_BY_NAME',
  assignedBy = 'ASSIGNED_BY',
  notes = 'NOTES',
  deliveryNote = 'DELIVERY_NOTE',
  deliveryDate = 'DELIVERY_DATE',
}

export enum ShipmentRequestStatus {
  Started = 'STARTED',
  InTransit = 'IN_TRANSIT',
  Returned = 'RETURNED',
  Delivered = 'DELIVERED',
  ArrivePickupLocation = 'ARRIVED_AT_PICKUP_LOCATION',
  Loaded = 'LOADED',
  ArriveDropOffLocation = 'ARRIVED_AT_DROP_OFF_LOCATION',
}

export enum RequestHistoryStatus {
  Failed = 'FAILED',
  Pass = 'PASS',
}

export enum RequestCreatedByType {
  Madar = 'MADAR',
  Admin = 'ADMIN',
  Customer = 'CUSTOMER',
  Fleet = 'FLEET',
  Driver = 'DRIVER',
  Receiver = 'RECEIVER',
  Organization = 'ORGANIZATION',
  Vendor = 'VENDOR',
  Bayan = 'Bayan',
  Cement = 'CEMENT',
}

export enum RequestHistoryAction {
  CreateShipment = 'CREATE_SHIPMENT',
  CarrierAllocated = 'CARRIER_ALLOCATED',
  DriverAccepted_order = 'DRIVER_ACCEPTED_ORDER',
  DriverPickedUp = 'DRIVER_PICKED_UP_ORDER',
  DriverArrived = 'DRIVER_IS_ABOUT_TO_ARRIVE',
  OrderDelivered = 'ORDER_IS_DELIVERED',
  OrderCancelled = 'ORDER_IS_CANCELLED',
  CarrierWayBillCreated = 'CARRIER_WAYBILL_CREATED',
  OrderIsResumed = 'ORDER_IS_RESUMED',
  CreateTrip = 'CREATE_TRIP',
  CreateOrder = 'CREATE_ORDER',
}

export enum ShipmentCreationTemplateTypes {
  Basic = 'BASIC',
  Cement = 'CEMENT',
  Orders = 'ORDER_ORIENTED',
  Bidding = 'BIDDING',
}

export enum RunningShipmentCheckType {
  Driver = 'DRIVER',
  Truck = 'TRUCK',
}

export enum WccIntegrationStatusType {
  WaitingAssignment = 'WAITING_ASSIGNMENT',
  Integrated = 'INTEGRATED',
  IntegrationFailed = 'INTEGRATION_FAILED',
  IntegrationInProgress = 'INTEGRATION_IN_PROGRESS',
  IntegrationCanceled = 'INTEGRATION_CANCELED',
  CancelationFAILED = 'CANCELATION_FAILED',
}

export enum StatusLabel {
  Hold = 'HOLD',
  Closed = 'CLOSED',
  Received = 'RECEIVED',
  Below = 'BELOW',
  Avg = 'AVERAGE',
  Superb = 'SUPERB',
  ForceClose = 'FORCE_CLOSE',
  AutoStart = 'AUTO_START',
  NoAnswer = 'NO_ANSWER',
}

/**
 * Marks the assign dialog as opened to change an existing assignment rather than to assign
 * a fleet. When set, the shipment keeps its current fleet — the fleet dropdown is locked —
 * while both the truck and the driver stay editable. The member picked only selects the
 * dialog title; it does not narrow the sibling control.
 */
export enum AssignmentScope {
  Truck = 'TRUCK',
  Driver = 'DRIVER',
}
